// The URL is the board context: refresh, Back and linked jobs recover the same
// category, query and facets. Only UI state is stored; no credentials or records.
export function readBoardFilters(params, empty) {
  return Object.fromEntries(Object.keys(empty).map(key => [key, params.get(key) || (key === 'q' ? params.get('conference') : '') || '']))
}
export function writeBoardFilters(previous, update, empty) {
  const next = new URLSearchParams(previous)
  const filters = typeof update === 'function' ? update(readBoardFilters(previous, empty)) : update
  for (const key of Object.keys(empty)) {
    if (filters[key]) next.set(key, filters[key]); else next.delete(key)
  }
  next.delete('conference'); next.delete('page'); next.delete('record')
  return next
}
